import { getGithubConnectUrl } from '../services/manage'

const RECONNECT_ERROR_CODES = ['GITHUB_RECONNECT_REQUIRED', 'GITHUB_NOT_CONNECTED']

export const isGithubConnected = (githubData) => !!githubData?.connected

// API errors meaning the GitHub connection is gone or expired and the user has to reconnect
export const isGithubReconnectError = (error) => RECONNECT_ERROR_CODES.includes(error?.code)

// The backend signs the OAuth state and picks the right GitHub page (install, re-authorise or
// configure repos). The tab is opened before the request so popup blockers don't eat it.
export const openGithubConnect = async (redirectUrl = window.location.href) => {
  const githubWindow = window.open('', '_blank')
  try {
    const { data } = await getGithubConnectUrl(redirectUrl)
    if (githubWindow) {
      githubWindow.location.href = data.url
    } else {
      window.location.href = data.url
    }
  } catch (error) {
    githubWindow?.close()
    throw error
  }
}
